import React, {useState} from "react";
import {collection, addDoc, getDocs, query, where} from "firebase/firestore";
import {db} from "../utils/firebase";
import {Link, useNavigate} from "react-router-dom";

const Register = () => {
	const navigate = useNavigate();
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");

	const handleRegister = async () => {
		try {
			// Check if the email already exists in the "Users" collection
			const usersRef = collection(db, "Users");
			const emailQuery = query(usersRef, where("email", "==", email));
			const emailSnapshot = await getDocs(emailQuery);

			if (emailSnapshot.size === 0) {
				// If email doesn't exist, add the user to the "Users" collection
				await addDoc(usersRef, {name, email, password});

				// Registration successful
				console.log("Registration successful");
				navigate("/login");
			} else {
				setError("Email already exists.");
			}
		} catch (error) {
			setError("Registration failed. Please try again.");
			console.error("Registration error:", error);
		}
	};
	return (
		<>
			<section className='bg-gray-50 dark:bg-gray-900'>
				<div className='flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0'>
					<div className='w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700'>
						<div className='p-6 space-y-4 md:space-y-6 sm:p-8'>
							<h1 className='text-center text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white'>
								Sign Up to your account
							</h1>
							<div className='space-y-4 md:space-y-6' action='#'>
								<div>
									<label
										for='email'
										className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
									>
										Your Name
									</label>
									<input
										type='email'
										value={name}
										onChange={e => {
											setName(e.target.value);
										}}
										name='email'
										id='email'
										className='bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
										placeholder='name@company.com'
										required=''
									/>
								</div>
								<div>
									<label
										for='email'
										className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
									>
										Your email
									</label>
									<input
										type='email'
										value={email}
										onChange={e => {
											setEmail(e.target.value);
										}}
										name='email'
										id='email'
										className='bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
										placeholder='name@company.com'
										required=''
									/>
								</div>
								<div>
									<label
										for='password'
										className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
									>
										Password
									</label>
									<input
										type='password'
										name='password'
										value={password}
										onChange={e => {
											setPassword(e.target.value);
										}}
										id='password'
										placeholder='••••••••'
										className='bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
										required=''
									/>
								</div>
								<button
									onClick={handleRegister}
									className='w-full bg-blue-700 text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800'
								>
									Register
								</button>
								<p className='flex justify-between text-sm font-light text-gray-500 dark:text-gray-400'>
									Don’t have an account yet?{" "}
									<Link
										to='/login'
										className='font-medium text-primary-600 hover:underline dark:text-primary-500'
									>
										Sign in
									</Link>
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Register;
